import React from "react";

export const AppContext = React.createContext(null);

/**
 * Fournit config, page et mode édition CMS à toute l'arborescence.
 */
export function AppProvider({ config: initialConfig, children }) {
    const [config, setConfig] = React.useState(initialConfig);
    const [page, setPage] = React.useState(0);
    const [editMode, setEditMode] = React.useState(false);

    const value = React.useMemo(
        () => ({ config, setConfig, page, setPage, editMode, setEditMode }),
        [config, page, editMode]
    );

    return <AppContext.Provider value={value}>{children}</AppContext.Provider>;
}

/** Hook utilitaire pour consommer AppContext */
export function useAppContext() {
    const ctx = React.useContext(AppContext);
    if (!ctx) throw new Error("useAppContext doit être utilisé dans AppProvider");
    return ctx;
}

